import { Coordinate, Line, Polygon, Project } from "@nova/protobuf"
import {
    colorValidators,
    coordinatesValidators,
    createLayerValidator,
    enumValidator,
    genericUpdateLayerValidator,
    strokeValidators,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { GeometryType } from "@nova/constants"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"

const coordinatesValidator = [
    {
        validator: (val: Coordinate[], args: Partial<Line>) => {
            return args.geometryType === GeometryType.Line ? val.length > 1 : val.length > 2
        },
        error: "Line does not have enough vertices",
    },
    ...coordinatesValidators,
]

const holesValidator = [
    {
        validator: (holes?: Polygon[]) => !!holes,
        error: "Hole list must exist, even if empty",
    },
]

const widthValidator = [
    {
        validator: (val: number) => val > 0,
        error: "Width must be greater than 0",
    },
]

export const createLineValidator = createLayerValidator(Line, {
    coordinates: { validators: coordinatesValidator, nonNull: true },
    holes: { validators: holesValidator, nonNull: true },
    geometryType: { validators: enumValidator("type", GeometryType), nonNull: true },
    width: { validators: widthValidator },
    color: { validators: colorValidators },
    outline: { validators: colorValidators },
    fill: { validators: colorValidators },
    stroke: { validators: strokeValidators },
    parentId: genericUpdateLayerValidator.parentId,
})

export const updateLineValidator = updateLayerValidator(Line, {
    coordinates: { validators: coordinatesValidator, nonNull: true },
    geometryType: { validators: enumValidator("type", GeometryType), nonNull: true },
    width: { validators: widthValidator },
    color: { validators: colorValidators },
    outline: { validators: colorValidators },
    fill: { validators: colorValidators },
    stroke: { validators: strokeValidators },
})

export const getDefaultLineCreateArgs = (project: Project, inParentId?: string) => ({
    visible: true,
    createdAt: dateAsNumber(),
    index: createNewLayerFractionalIndex(project, 0, inParentId),
    // parentId would never got autopopulated
    parentId: undefined,
})

export type CreateLineArgs = UnionToTuple<keyof typeof createLineValidator>
export type UpdateLineArgs = UnionToTuple<keyof typeof updateLineValidator>
